import gql from 'graphql-tag';

export const UPDATE_USER_EMAIL_MUTATION = gql`
  mutation UpdateUserEmail($email: String!) {
    updateUserEmail(email: $email)
  }
`;
